import React, {FunctionComponent, useEffect} from 'react';

import {ITravel} from "../../../models/Travel/Travel";
import {arraySum, displayDate, displayDollarAmount} from "../../../lib/utilities";
import {observer} from "mobx-react-lite";
import Agent from "../../../api/Agent";
import {useAPIPager} from "../../../hooks/useAPIPager";
import {useSelectTable} from "../../../hooks/useSelectTable";
import Table from '../../table/Table';
import THead from '../../table/THead';
import TR from '../../table/TR';
import TD from "../../table/TD";
import TBody from '../../table/TBody';
import Pagination from "../../table/Pagination";
import Skeleton from "../../generic/Skeleton";
import Checkbox from "../../Inputs/Checkbox";

interface OwnProps {
    onChange?: (e: string[]) => (void)
    selected?: string[]
    predicates?: Map<any, any>
}

type Props = OwnProps;

const TravelSelectTable: FunctionComponent<Props> = ({onChange, selected, predicates}) => {
    // Pager
    const {items, count, handleChangePage, isLoading} = useAPIPager(Agent.Travel, predicates)
    const {handleCheckAll, handleCheck, selectedItems} = useSelectTable(selected);

    // Use Effects
    useEffect(() => {
        !!onChange && onChange(selectedItems)
    }, [selectedItems]);

    return (<>
        <span className="sr-only" id="travelSelectTable">Shipping and Tax</span>
        <Table className={'max-w-full'} aria-describedby={'travelSelectTable'}>
            <THead>
                <TR>
                    <TD className={'th min-w-max whitespace-nowrap'}>
                        {items.length > 0 && <>
                            <span id="selectAllTravel" className="sr-only">Select all</span>
                            <Checkbox label={<span className={'sr-only'}>Select</span>}
                                checked={items.every(i => selectedItems?.includes(i.id))}
                                className="border-gray-300 rounded"
                                onChange={(e) => handleCheckAll(e, items)}/></>}
                    </TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Technician</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Start Date</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>End Date</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Cost</TD>
                </TR>
            </THead>
            <TBody>
                {items?.map((travel: ITravel, idx) => {
                    return (<TR key={idx}>
                        {isLoading ? <TD colSpan={100}><Skeleton/></TD> : <>
                            <TD className={'td min-w-max whitespace-nowrap'}>
                                <Checkbox checked={selectedItems.includes(travel.id ?? '')}
                                       onChange={handleCheck} value={travel.id}
                                label={<span className={'sr-only'}>Select</span>}
                                />
                            </TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{travel?.technicianName}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDate(travel?.travelStartDate)}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDate(travel?.travelEndDate)}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDollarAmount(arraySum([
                                travel.travelCosts,
                                travel.travelTimeCosts,
                                travel.interStateCosts,
                                travel.intraStateCosts,
                                travel.auxiliaryAidCosts,
                            ]))}</TD>
                        </>}
                    </TR>)
                })}
            </TBody>
        </Table>
        <Pagination totalRows={count} onPageChange={handleChangePage} onRowChange={handleChangePage}/>
    </>);
};

export default observer(TravelSelectTable);
